import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => (
  <div className="max-w-2xl mx-auto px-4 py-16 min-h-[70vh] flex items-center">
    <div className="w-full bg-white border border-neutral-200 rounded-sm p-8 md:p-10 text-center">
      <XCircle className="w-14 h-14 text-neutral-400 mx-auto mb-4" data-testid="payment-cancelled" />
      <h1 className="text-2xl font-black text-[#12263A] mb-2">Payment cancelled</h1>
      <p className="text-sm text-neutral-600 mb-6">
        No worries — nothing was charged. Your basket is still ready when you are.
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        <Link to="/cart" className="bg-[#F46A25] hover:bg-[#e05a15] text-white font-bold text-sm px-4 py-2 rounded-sm">
          Return to basket
        </Link>
        <Link to="/" className="bg-white border border-neutral-300 hover:border-[#F46A25] text-[#12263A] font-bold text-sm px-4 py-2 rounded-sm">
          Continue shopping
        </Link>
      </div>
    </div>
  </div>
);

export default PaymentCancelPage;
